import { createContext } from 'react';
import { Callbacks } from './types';
export const TwoFAContext = createContext<{
  confirm2FA: (data: Callbacks) => (code: string) => Promise<string>;
  open2FA: (data: { cb?: () => void }) => Promise<void>;
  close2FA: () => void;
  fetchActive2FAMethod: () => Promise<void>;
  sendOtp: () => Promise<void>;
  modeActive: string;
  activeMethodData: any;
  is2FAVerified: boolean;
}>(null);
